import { useEffect, useState } from 'react';
import { makeTheme } from '../themeUtils';
import { defaultTheme } from '../theme';

function useDynamicTheme(initialTheme, navigationColor, highlightColor) {

    const x = true;
    // navigationColor value will be non-empty string once is loaded
    if (!navigationColor) {

        // this is a fail-safe, to ensure the loader will displayed
        // in the edge case that the theme has not been set after x seconds
        const timeoutId = setTimeout(() => {
        }, 10_000);

        return () => {
            if (timeoutId) {
                initialTheme = defaultTheme;
                clearTimeout(timeoutId);
                return { initialTheme, x };
            }
        };

    }
    else {
        return makeTheme(initialTheme, highlightColor, navigationColor), x
    }

};

export default useDynamicTheme;
